import _ from 'lodash';
import IAddress1UnitNoZipCode from '../common/IAddress1UnitNoZipCode';
import IMLSPropertySource from './IMLSPropertySource';
import IMLSPropertyItem from './IMLSPropertyItem';
import IMLSPropertyData from './IMLSPropertyData';
import MlsPropertyItemUtils from './MlsPropertyItemUtils';

export default {
    /**
     * Get a MLS property item from the given MLS property data by the given combined address1 and unit number.
     * @param mlsPropertyData
     * @param address1AndUnitNo
     * @returns The first matching MLS property item or null when no matches found.
     */
    getByAddress1AndUnitNo(mlsPropertyData: IMLSPropertyData, address1AndUnitNo: string): IMLSPropertyItem | null {
        if (mlsPropertyData) {
            for (const propertyItem of mlsPropertyData) {
                const propertyAddress1AndUnitNo = MlsPropertyItemUtils.combineAddress1AndUnitNo(propertyItem);
                if (propertyAddress1AndUnitNo === address1AndUnitNo) {
                    return propertyItem;
                }
            }
        }
        return null;
    },

    /**
     * Get a MLS property item from the given MLS property data by the given address1, unit number and zip code.
     * @param propertyData
     * @param criteria
     * @returns The first matching MLS property item or null when no matches found.
     */
    getByAddress1UnitNoAndZipCode(propertyData: IMLSPropertyData, criteria: IAddress1UnitNoZipCode): IMLSPropertyItem | null {
        for (const propertyItem of propertyData) {
            const matches = MlsPropertyItemUtils.matches(propertyItem, criteria);
            if (matches) {
                return propertyItem;
            }
        }
        return null;
    },

    getPropertySourceByFormFieldName(propertyItem: IMLSPropertyItem, fieldName: string): IMLSPropertySource[] | null | undefined {
        let result: IMLSPropertySource[] | null | undefined;
        for (const idx in propertyItem.fields) {
            if (propertyItem.fields[idx].formFieldName === fieldName) {
                result = propertyItem.fields[idx].propertySource;
                break;
            }
        }
        return result;
    },

    getPropertySourceByParentFormFieldName(propertyItem: IMLSPropertyItem, fieldName: string): IMLSPropertySource[] | null | undefined {
        const result = [];
        for (const idx in propertyItem.fields) {
            if (propertyItem.fields[idx].parentFormFieldName === fieldName) {
                // TODO: not make this an any
                const items: any = _.cloneDeep(propertyItem.fields[idx].propertySource);
                for (const item in items) {
                    result.push(items[item]);
                }
            }
        }
        return result;
    },

    /**
     * Get the index of the given MLS property item in the given MLS property data, matching on
     * address1, unit number and zip code.
     * @param propertyData
     * @param propertyItem
     * @returns The index in the array when a match is found, -1 otherwise
     */
    getIndexByPropertyItem(propertyData: IMLSPropertyData, propertyItem: IMLSPropertyItem): number {
        let result = -1;

        if (propertyItem) {
            const address1UnitNoZipCode = MlsPropertyItemUtils.getAddress1UnitNoAndZipCode(propertyItem);

            for (const idx in propertyData) {
                const propItem = propertyData[idx];
                const matches = MlsPropertyItemUtils.matches(propItem, address1UnitNoZipCode);
                if (matches) {
                    result = Number(idx);
                    break;
                }
            }
        }
        return result;
    }
};
